export const THEMES = {
    dark: 'dark',
    light: 'light',
} as const;
